import Vue from 'vue';
// Or as a directive-only
import {VueMaskDirective} from 'v-mask';

Vue.directive('mask', VueMaskDirective);
